import {AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {StorageService} from '../../../../Services/storage.service';
import {FilterPipe} from 'ngx-filter-pipe';
import {EmailService} from '../../../../Services/email.service';
import {DatePipe, DecimalPipe} from '@angular/common';
import {AppConfigService} from '../../../../Services/app-config.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {RoutingTrackerService} from '../../../../Services/routing-tracker.service';
import {EmailModel} from '../../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {DataExportService} from '../../../../Services/dataExport.service';
import {firstValueFrom} from 'rxjs';
import {ReportPrintService} from '../../../../Services/report-print.service';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.css'],
  standalone: false
})
export class PaymentsComponent implements OnInit, AfterViewInit, AfterViewChecked {

  public queryParams: any = [];
  private rptName: string;
  public urlParams: any = [];
  public vm: any = {
    report: [],
    request: {
      fromDate: null,
      toDate: null,
      entity_id: null,
      batch_id: null,
    },
    newBatch: {
      audit_sequnece: null,
    },
    fromDateSelect: null,
    toDateSelect: null,
    monthCount: null,
    subLedger: null,
    entity: [],
    entityType: [],
    location: [],
    currency: [],
    rfType: [],
    rf1: [],
    rf2: [],
    rf3: [],
    rf4: [],
    rf5: [],
    entityCity: [],
    entityState: [],
    bank: [],
    paymentType: [],
    company: [],
    buttonsDisabled: false,
    entityFilter: { name: null },
    batchFilter: { description: null },
    batch: [],
    entityInput: '',
    entityName: [],
    startEntity: 0,
    fromDateError: null,
    toDateError: null,
    dateError: null,
    entity_email: '',
    email: {
      toemail: null,
      fromemail: this.appConfig.SysEmailAddress,
      PdfHtml: null,
      Subject: null,
    },
    showEmail: true,
    paymentFilter: {
      search_string: null,
    },
    payment: [],
    updateBatch: null,
    batchName: [],
    startBatch: 0,
    startBatchName: 0,
    batchInput: null,
    reportTotal: 0,
  };

  routedFrom = '';

  // Email modal integration and standard header button config
  reportDataToSendInEmail: EmailModel = new EmailModel();
  buttonConfig: any = {
    reportFormat: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
    close: true,
  };

  constructor(
    public tableDataService: DataService,
    public dateFilter: DateFilterService,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    public localStorage: StorageService,
    public notification: BsToastService,
    public aEmail: EmailService,
    public appConfig: AppConfigService,
    public prevUrl: RoutingTrackerService,
    public excelExporter: DataExportService,
    private reportPrint: ReportPrintService
  ) {
    const prevUrl2 = this.prevUrl.getPreviousUrl();

    if (prevUrl2 !== null && prevUrl2 !== undefined) {
      this.routedFrom = prevUrl2;
    } else {
      this.routedFrom = '';
    }
  }

  ngOnInit() {
    this.urlParams = this.route.snapshot.queryParams;

    this.vm.subLedger = this.urlParams.subLedger;
    this.vm.batchId = this.urlParams.batch_id;

    this.FilterOptionsInit().then();
    this.newDateFilter(this.vm.request.toDate, this.vm.request.fromDate);
    this.rptName = $localize`:Payments @@payments:Payments`;
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.vm.subLedger.toUpperCase() + ' ' + this.rptName + ' Report');
    // console.log('Time Out --> ' + this.timeOut);
  }

  ngAfterViewChecked() {
    // No-op: unified email/print HTML is built on demand
  }

  newDateFilter(toDate, fromDate) {
    const ret = this.dateFilter.DateFilterInit(toDate, fromDate);
    this.vm.fromDateSelect = ret.fromDateSelect;
    this.vm.toDateSelect = ret.toDateSelect;
    this.vm.monthCount = ret.monthCount;
  }

  async FilterOptionsInit() {
    // this.tableDataService.getData('entity?state=active').subscribe((result: any[]) => {
    //   this.vm.entity = result;
    //   for (const [x, value] of Object.entries(this.vm.entity)) {
    //     this.vm.entityName.push({name: this.vm.entity[x].name});
    //   }
    // });
    this.tableDataService
      .getData('entity_type?state=active&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.entityType = result.Data;
      });
    this.tableDataService
      .getData('location?state=active&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.location = result.Data;
      });
    this.tableDataService
      .getData('company?state=active&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.company = result.Data;
        // console.log(JSON.stringify(result));
      });
    this.tableDataService
      .getData('currency?state=active&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.currency = result.Data;
      });
    this.tableDataService
      .getData('reporting_field_type?state=active&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.rfType = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf1&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf1 = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf2&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf2 = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf3&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf3 = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf4&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf4 = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf5&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf5 = result.Data;
      });
    // Load payment types for filter dropdown (used by Pay Type filter)
    this.tableDataService
      .getData('payment_type', '?state=active&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.paymentType = result?.Data || [];
      });
    this.vm.entity = await this.getFilterValues('entity', '?state=active');
    for (const [x, value] of Object.entries(this.vm.entity)) {
      this.vm.entityName.push({ name: this.vm.entity[x].name });
    }

    let tempBatchType = null;
    if (this.vm.subLedger === 'ap') {
      tempBatchType = '5';
    } else if (this.vm.subLedger === 'ar') {
      tempBatchType = '3';
    }
    // else if (this.vm.subLedger === 'sq') {
    //   tempBatchType = '8';
    // } else if (this.vm.subLedger === 'so') {
    //   tempBatchType = '9';
    // } else if (this.vm.subLedger === 'po') {
    //   tempBatchType = '10';
    // }

    this.tableDataService.getData('t_batch/?batchType=' + tempBatchType).subscribe((result: any[]) => {
      // this.tableDataService.getData('t_batch', '?state=active').subscribe((result) => {
      this.vm.batch = result;
      // console.log(JSON.stringify(result));
      for (const [x, value] of Object.entries(this.vm.batch)) {
        this.vm.batchName.push({ name: this.vm.batch[x].description });
      }

      // run this if batch passed in url
      if (this.vm.batchId) {
        this.vm.batch.forEach(x => {
          if (x.id === this.vm.batchId) {
            // console.log(x);
            this.vm.batchInput = x.description;
            this.vm.request.batch_id = x.id;
            this.update();
          }
        });
      }

    });

    if (this.urlParams.entity_id != null || this.urlParams.entity_id != undefined) {
      for (const [y, value] of Object.entries(this.vm.entity)) {
        // console.log('outside if:' + this.vm.entity[y].id);
        if (this.vm.entity[y]) {
          // console.log('inside if:' + this.vm.entity[y].id);
          if (this.vm.entity[y].id == this.urlParams.entity_id) {
            this.vm.entityInput = this.vm.entity[y].name;
            this.vm.request.entity_id = this.vm.entity[y].id;
            this.vm.request.entity_email = this.vm.entity[y].email;
            // console.log('break:' + this.vm.entityInput);
            break;
          }
        }
      }
    }

    const hasUrlDates = !!(this.urlParams.fromDate || this.urlParams.toDate);
    if (this.urlParams.fromDate) {
      this.vm.request.fromDate = this.urlParams.fromDate;
      this.vm.showSpecificDates = true;
    }

    if (this.urlParams.toDate) {
      this.vm.request.toDate = this.urlParams.toDate;
      this.vm.showSpecificDates = true;
    }

    if (!this.vm.request.toDate && !this.vm.request.fromDate) {
      this.newDateFilter(new Date(), new Date());
      const range = this.dateFilter.GetDefaultDateRange('span', this.vm.fromDateSelect, this.vm.toDateSelect);
      this.vm.request.toDate = range.toDate;
      this.vm.request.fromDate = range.fromDate;
    }

    this.newDateFilter(this.vm.request.toDate, this.vm.request.fromDate);

    if (hasUrlDates && this.vm.request.toDate && this.vm.request.fromDate && this.vm.batchId) {
      this.update();
    } else if (hasUrlDates && this.vm.request.toDate && this.vm.request.fromDate && this.vm.request.entity_id) {
      this.update();
    }
  }

  async getFilterValues(tablename, param) {
    let values: any;
    values = null;
    try {
      const result = await firstValueFrom(
        this.tableDataService.getData(tablename + param + '&pageNumber=0&pageSize=99999')
      );
      values = result.Data;
    } catch (error) {
      console.error('Error fetching filter values:', error);
    }
    return values;
  }


  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  update() {
    let inputError = false;
    if (!this.vm.request.toDate) {
      this.vm.toDateError = true;
      inputError = true;
      this.notification.showWarningToast($localize`:To Date is required. @@toDateisrequired:To Date is required.`);
    }
    if (!this.vm.request.fromDate) {
      inputError = true;
      this.vm.fromDateError = true;
      this.notification.showWarningToast($localize`:From Date is required. @@fromDateisrequired:From Date is required.`);
    }
    const tempToDate: any = new Date(this.vm.request.toDate);
    const tempFromDate: any = new Date(this.vm.request.fromDate);
    if (tempToDate - tempFromDate < 0) {
      this.vm.dateError = true;
      inputError = true;
      this.notification.showWarningToast(
        $localize`:The To Date must be greater than the From Date. @@theToDatemustbegreaterthantheFromDate:The To Date must be greater than the From Date.`
      );
    }
    if (!inputError) {
      this.vm.buttonsDisabled = true;
      this.vm.request.toDate = this.dateFilter.GetDateFormat(this.vm.request.toDate);
      this.vm.request.fromDate = this.dateFilter.GetDateFormat(this.vm.request.fromDate);
      // this.localStorage.StorageSet('toDate', this.vm.request.toDate);
      // this.localStorage.StorageSet('fromDate', this.vm.request.fromDate);
      // console.log('co:' + this.vm.request.company_id);
      const urlParamsJson = {
        fromDate: this.vm.request.fromDate,
        toDate: this.vm.request.toDate,
        subLedger: this.vm.subLedger,
        // Ensure cleared entity sends an explicit empty value to clear server-side filtering
        entity_id: this.vm.request.entity_id ? this.vm.request.entity_id : '',
        company_id: this.vm.request.company_id === undefined ? null : this.vm.request.company_id,
        batch_id: this.vm.request.batch_id,
        payment_type_id: this.vm.request.payment_type_id ?? null,
      };

      // console.log(urlParamsJson);
      const urlParams: string = this.encodeQueryData(urlParamsJson);
      this.tableDataService.getData('PaymentReport', '?' + urlParams).subscribe((result) => {
        this.vm.report = result;
        // console.log(result);
        if (!this.vm.report.length) {
          this.notification.showWarningToast('No data matching selection criteria');
          this.vm.buttonsDisabled = false;
          return;
        }
        this.vm.reportTotal = (result as any[]).reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
        this.vm.buttonsDisabled = false;
        this.vm.toDateError = false;
        this.vm.fromDateError = false;
        this.vm.dateError = false;
        // console.log(JSON.stringify(result));
        let useDate;
        // when batch sent need to use batch items oldest from date - doesnt search on it but looks weird to user if not
        // using batchid only in api
        if (this.vm.batchId && result) {
          // sorted desc so just pick last one
          this.vm.report.forEach(x => {
            useDate = x.header_date;
          });
          // convert so Date understands
          useDate = new DatePipe('en-US').transform(useDate, 'MM/dd/yyyy');
          let oldestDate = new Date(useDate);
          // back up one month and go to first day of month
          oldestDate = new Date(oldestDate.getFullYear(), oldestDate.getMonth() - 1, 1);
          this.vm.request.fromDate = new DatePipe('en-US').transform(oldestDate, 'MM/dd/yyyy');
        }
      });
    }
  }

  updateEntity() {
    this.vm.buttonsDisabled = true;
    // this.localStorage.StorageSet('entity', '');
    this.tableDataService
      .getData('entity', '?state=active&pageNumber=0&pageSize=99999')
      .subscribe((result: ResponseModel) => {
        this.vm.entity = result.Data;
        this.vm.buttonsDisabled = false;
      });
  }

  selectEntityModal(entityName) {
    this.vm.request.entity_id = '';
    if (this.vm.request.entity_id == '' || 1 === 1) {
      for (const [y, value] of Object.entries(this.vm.entity)) {
        if (this.vm.entity[y].name == entityName) {
          this.vm.entityInput = entityName;
          this.vm.request.entity_id = this.vm.entity[y].id;
          this.vm.entity_email = this.vm.entity[y].email;
          this.vm.report = [];
          break;
        }
      }
    }
  }

  // New handler: clear entity selection from child component
  onEntityCleared() {
    this.vm.request.entity_id = '';
    this.vm.entityInput = '';
    this.vm.entity_email = '';
    // Clear current report so next Update reflects cleared filter
    this.vm.report = [];
  }

  testEntity() {
    const entityIdStart = this.vm.request.entity_id;
    if (!this.vm.entityInput || this.vm.entityInput == '' || this.vm.entityInput == null) {
      this.vm.request.entity_id = '';
    } else {
      if (this.FilterObject(this.vm.entity, { name: this.vm.entityInput }).length > 0) {
        const entityId = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].id;
        const entityName = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].name;
        const entityEmail = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].email;
        if (entityId != '' || entityId != null) {
          this.vm.request.entity_id = entityId;
          this.vm.entityInput = entityName;
          this.vm.entity_email = entityEmail;
        } else {
          this.vm.request.entity_id = '';
          this.vm.entity_email = '';
        }
      } else {
        this.vm.request.entity_id = '';
        this.vm.entity_email = '';
      }
    }
    if (entityIdStart != this.vm.request.entity_id) {
      this.vm.report = [];
    }
  }

  updateBatch() {
    this.vm.buttonsDisabled = true;
    this.vm.startBatchName = 0;
    let tempBatchType = null;
    if (this.vm.subLedger === 'ap') {
      tempBatchType = '5';
    } else if (this.vm.subLedger === 'ar') {
      tempBatchType = '3';
    }
    // } else if (this.vm.subLedger === 'sq') {
    //   tempBatchType = '8';
    // } else if (this.vm.subLedger === 'so') {
    //   tempBatchType = '9';
    // } else if (this.vm.subLedger === 'po') {
    //   tempBatchType = '10';
    // }
    this.tableDataService.getData('t_batch', '?state=active&batchType=' + tempBatchType).subscribe((result) => {
      // this.tableDataService.getData('t_batch', '?state=active').subscribe((result) => {
      this.vm.batch = result;
      this.vm.buttonsDisabled = false;
    });
  }

  selectBatch(batchName) {
    this.vm.request.batch_id = '';
    if (this.vm.request.batch_id == '' || 1 === 1) {
      for (const [y, value] of Object.entries(this.vm.batch)) {
        if (this.vm.batch[y].description == batchName) {
          this.vm.batchInput = batchName;
          this.vm.request.batch_id = this.vm.batch[y].id;
          this.vm.report = [];
          break;
        }
      }
    }
  }

  testBatch() {
    const batchIdStart = this.vm.batchId;
    if (!this.vm.batchInput || this.vm.batchInput == '' || this.vm.batchInput == null) {
      this.vm.request.batch_id = undefined;
    } else {
      if (this.FilterObject(this.vm.batch, { description: this.vm.batchInput }).length > 0) {
        const batchId = this.FilterObject(this.vm.batch, { description: this.vm.batchInput }, true)[0].id;
        if (batchId != '' || batchId != null) {
          this.vm.request.batch_id = batchId;
        }
      }
    }
    if (batchIdStart != this.vm.request.batch_id) {
      this.vm.report = [];
    }
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      // Allow entity_id to be sent even when empty to explicitly clear server-side filtering
      if (data[d] != null && (data[d] !== '' || d === 'entity_id')) {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
    return ret.join('&');
  }

  close() {
    if (this.routedFrom) {
      this.router.navigateByUrl(this.routedFrom).then();
    } else if (this.routedFrom === '' || this.routedFrom == undefined) {
      window.close();
    } else {
      this.router.navigateByUrl('/home').then();
    }
  }

  clear() {
    this.vm.reportTotal = 0;
    this.vm.request = {
      fromDate: null,
      toDate: null,
      entity_id: null,
      batch_id: null,
    };
    this.vm.report = [];
  }

  // Excel export hooked to header button
  exportToExcel() {
    try {
      const name = `${(this.vm?.subLedger || '').toString().toUpperCase()} Payments Report.xlsx`;
      this.excelExporter.exportHtmlToExcel(this.buildExportHtml(), name);
    } catch (e) {
      console.error('Payments export failed', e);
    }
  }

  // Prepare email using unified HTML builder and open shared modal
  setEmailData() {
    const emailDocObj = {} as EmailModel;
    const reportName = `${(this.vm?.subLedger || '').toString().toUpperCase()} Payments Report`;

    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';
    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '' as any;
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + reportName + '.<br><br><br>'
      + 'Best regards,'
      + '<br><br>'
      + 'AcctXErp'
      + '<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + reportName;

    try {
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch {
      emailDocObj.pdfHtml = '';
    }
    emailDocObj.activity_message = reportName;

    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    emailDocObj.FileName = `${(this.vm?.subLedger || 'Payments').toString().toUpperCase()}_Payments_Report_${yyyy}${mm}${dd}.pdf`;

    this.reportDataToSendInEmail = emailDocObj;

    const element = document.getElementById('sendEmailModal') as HTMLElement;
    if (element) {
      const emailModal = new Modal(element);
      emailModal.show();
    }
  }

  // Print the report content using a generated HTML document (do not use PrintService)
  printReport() {
    try {
      const html = this.buildPrintHtml();
      this.printHtmlInIframe(html);
    } catch (e) {
      console.error('Payments print failed', e);
      this.notification?.showWarningToast?.('Unable to print Payments Report');
    }
  }

  // Build export table HTML from data (no DOM dependency)
  private buildExportHtml(): string {
    const fmt = (v: number) => new DecimalPipe('en-US').transform(Math.abs(v), '1.2-2') || '0.00';
    const cell = (v: number) => v >= 0 ? fmt(v) : `(${fmt(v)})`;
    const rows: string[] = [];
    const report: any[] = this.vm.report || [];
    for (const r of report) {
      const dateStr = r.header_date ? new Date(r.header_date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }) : '';
      const docType = r.amount >= 0 ? 'Payment' : 'Refund';
      const unappliedStyle = 'white-space:nowrap;text-align:right;font-weight:bold;border-bottom:1px solid #ddd;padding:4px' + (r.unapplied != 0 ? ';color:#dc3545' : '');
      const appliedRows = (r.details || []).map((d: any) => {
        const dType = d.applied_amount >= 0 ? 'Invoice' : 'Credit';
        return `<tr><td>${dType}: ${d.number || ''}</td><td>${d.entity_name !== r.entity_name ? d.entity_name || '' : ''}</td><td>${d.description || ''}</td></tr>`;
      }).join('');
      rows.push(`<tr>
        <td style="border-bottom:1px solid #ddd;padding:4px"><strong>${docType}: ${r.number || ''}${!this.vm.entity_id ? ' &bull; ' + (r.entity_name || '') : ''}${r.location_name && !this.vm.location_id ? ' &bull; ' + r.location_name : ''}${r.description ? ' &bull; ' + r.description : ''}</strong></td>
        <td style="white-space:nowrap;text-align:center;border-bottom:1px solid #ddd;padding:4px">${dateStr}</td>
        <td style="white-space:nowrap;text-align:center;border-bottom:1px solid #ddd;padding:4px">${r.payment_type_name || r.paymentTypeName || ''}</td>
        <td style="white-space:nowrap;text-align:right;font-weight:bold;border-bottom:1px solid #ddd;padding:4px">${cell(r.amount)}</td>
        <td style="${unappliedStyle}">${r.unapplied !== 0 ? cell(r.unapplied) : ''}</td>
        <td style="padding:0"><table>${appliedRows}</table></td>
      </tr>`);
    }
    const thStyle = 'border-bottom:2px solid #ddd;padding:4px;';
    const tfoot = this.vm.reportTotal !== undefined ? `<tfoot><tr>
      <th colspan="2" style="text-align:left;padding:4px">Report Total</th>
      <th style="text-align:right;padding:4px">${cell(this.vm.reportTotal)}</th>
      <th colspan="2"></th>
    </tr></tfoot>` : '';
    return `<table width="100%" style="border-spacing:0;border-collapse:collapse">
      <thead><tr>
        <th style="${thStyle}">Payment</th>
        <th style="${thStyle}text-align:center">Date</th>
        <th style="${thStyle}text-align:center">Pay Type</th>
        <th style="${thStyle}text-align:right">Payment (Refund)</th>
        <th style="${thStyle}text-align:right">Unapplied</th>
        <th style="${thStyle}">Applied to Invoices</th>
      </tr></thead>
      <tbody>${rows.join('')}</tbody>
      ${tfoot}
    </table>`;
  }

  // Build a self-contained HTML for printing/emailing the current report
  private buildPrintHtml(forEmail: boolean = false): string {
    const rawContent = this.buildExportHtml();
    const content = this.reportPrint.cleanContentHtml(rawContent);
    const from = this.vm?.request?.fromDate || '';
    const to = this.vm?.request?.toDate || '';
    const meta: { label: string; value: string }[] = [];
    if (from || to) {
      meta.push({label: 'Period', value: from && to ? `${from} to ${to}` : (from || to)});
    }
    return this.reportPrint.buildHtml({title: 'Payments', contentHtml: content, meta, orientation: 'landscape'});
  }

  // Utility to print HTML in a hidden iframe and clean up afterward
  private printHtmlInIframe(html: string): void {
    this.reportPrint.printInIframe(html);
  }

  private escapeHtml(text: string): string {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}
